import { useObservableState } from 'observable-hooks';
import React, { useState } from 'react';
import { map } from 'rxjs/operators';
import { useService } from '../../../services/services';
import { FormData, formDataFromReq } from './create';
import StepSummary from './step-summary';
import FodderNeedPeriodType from '../../../enums/fodder-need-period-type';
import { Option } from '../../../components/form/elements/select';
import ClassifierGroup from '../../../enums/classifier-group';
import Classifier from '../../../enums/classifier';
import ClassifierPropertyKey from '../../../enums/classifier-property-key';
import { useParams } from 'react-router-dom';

export default function ViewFodderNeed() {
  const [modal] = useState(null);
  const { fodderNeedService, classifierService } = useService();
  const [classifiers] = useObservableState<Option[]>(
    () =>
      classifierService
        .values(ClassifierGroup.WAREHOUSE, Classifier.PRODUCT_TYPES, {
          [ClassifierPropertyKey.DRY_MATTER]: true,
        })
        .pipe(
          map((values) =>
            values.map((value) => {
              return {
                value: value.id,
                label: value.value,
                parentValue: value.parent.value,
                properties: value.properties,
              };
            })
          )
        ),
    null
  );

  const periods = [FodderNeedPeriodType.WINTER, FodderNeedPeriodType.SUMMER];

  const { farmId, id } = useParams<{
    farmId: string;
    id: string;
  }>();

  const [formData] = useObservableState<FormData>(
    () =>
      fodderNeedService.show(farmId, id).pipe(
        map((fodderNeed) => {
          return formDataFromReq(fodderNeed, farmId, periods);
        })
      ),
    null
  );

  return (
    formData &&
    classifiers && (
      <>
        <StepSummary
          formData={formData}
          periods={periods}
          classifiers={classifiers}
          onlyTotal={true}
        />
        {modal}
      </>
    )
  );
}
